module.exports = __webpack_public_path__ + "img/syl_gallery10.df5a08b3.jpg";